import { z } from "zod";
const ExpireStableTransferRequestsInputSchema = z
    .object({ limit: z.number().int().min(1).max(500).default(100) })
    .strict();
/**
 * Idempotently flips PENDING Stable Transfer requests past their
 * `expiresAt` to `EXPIRED`, mirroring `expireOwnerLinkRequests` exactly. Not
 * yet wired to a scheduled worker — see the completion report, matching the
 * same not-yet-scheduled state Phase 6-8 shipped their own scan/expiry jobs
 * in. `respondStableTransfer` independently re-checks `expiresAt` on every
 * accept/decline, so correctness never depends on this actually running on
 * a schedule.
 */
export async function expireStableTransferRequests(input, dependencies) {
    const parsed = ExpireStableTransferRequestsInputSchema.parse(input);
    const expired = await dependencies.repository.expireDueStableTransferRequests({ now: dependencies.clock.now(), limit: parsed.limit });
    return { expired };
}
